// extracted by mini-css-extract-plugin
export default {"contents":"lK-z","sectionHeading":"mK-z"};